import { ClickAwayListener, Tooltip, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import { type FC, useState } from "react";

const INFO_TOOLTIP_MAX_WIDTH = 260;

type Props = {
	title: string;
};

export const ChartInfoTooltip: FC<Props> = ({ title }) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<Tooltip
				PopperProps={{
					modifiers: [{ name: "offset", options: { offset: [80, -15] } }],
				}}
				open={open}
				disableTouchListener
				disableFocusListener
				disableHoverListener
				placement="top"
				title={title}
				slotProps={{
					tooltip: {
						sx: {
							bgcolor: theme.palette.background.paper,
							color: theme.palette.grey[900],
							boxShadow: theme.shadows[3],
							borderRadius: theme.radii.md,
							fontWeight: theme.typography.bodyStrong.fontWeight,
							fontSize: theme.typography.caption.fontSize,
							maxWidth: INFO_TOOLTIP_MAX_WIDTH,
							px: theme.spacingTokens.md,
							py: theme.spacingTokens.sm,
						},
					},
				}}
			>
				<Info
					size={theme.iconSize.xs}
					color={theme.palette.grey[400]}
					onClick={() => setOpen((prev) => !prev)}
					style={{ cursor: "pointer" }}
				/>
			</Tooltip>
		</ClickAwayListener>
	);
};
